import cookie from 'js-cookie'
import axios from 'axios'
import { setupCache } from 'axios-cache-interceptor'

const baseDomain = location.hostname.split('.').slice(-2).join('.')
const apiDomain = import.meta.env.VITE_API_DOMAIN ?? `api.${baseDomain}`

const token = cookie.get('EWS_AUTH_KEY')

const api = setupCache(
  axios.create({
    baseURL: `https://${apiDomain}`,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    timeout: 10000
  })
)

// Add a request interceptor to add cache params
api.interceptors.request.use((config) => {
  let defaultCache = {
    ttl: 5 * 1000, // 5 second default
    interpretHeader: false,
    cachePredicate: {
      ignoreUrls: []
    },
    override: false
  }
  if (typeof config?.cache?.maxAge !== 'undefined') {
    defaultCache.ttl = config.cache.maxAge
  }
  if (typeof config?.cache?.exclude?.query !== 'undefined') {
    if (config.cache.exclude.query) {
      defaultCache.cachePredicate.ignoreUrls = [/\?.+/] // // Ignore URLs that contain "?" (i.e., have query parameters)
    }
  }
  if (typeof config?.cache?.ignoreCache !== 'undefined') {
    defaultCache.override = config.cache.ignoreCache
    // or
    // defaultCache = false
  }

  config.cache = defaultCache
  return config
})

export default api
